<template>
  <div>
    <p class="h5 text-center">
      Grant
      <span class="text-orange font-weight-bold"> {{ coins }} coins </span> to
      <span class="text-capitalize">{{ getChildSelectedName }}</span>
    </p>

    <hr class="my-3" />

    <b-row class="align-items-center" align-h="center">
      <b-col cols="6" sm="3" class="d-flex align-items-center flex-column cursor"
          v-on:click="UnDone">
        <i
          class="rounded-circle material-icons text-light p-1 bg-danger biger-icon"
          >clear</i
        >
        <small class="font-weight-bolder text-uppercase h5 mt-1 text-danger"
          >No</small
        >
      </b-col>
      <b-col cols="6" sm="3" class="d-flex align-items-center flex-column cursor"
          v-on:click="Done">
        <i
          class="rounded-circle material-icons p-1 text-light bg-success biger-icon"
          >done</i
        >
        <small class="font-weight-bolder text-uppercase h5 mt-1 text-success"
          >Confirm</small
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    coins: Number,
    idCoins:{type:Number,required:true}
  },
  data() {
    return {
      requestSent:false
    }
  },
  computed: {
    ...mapGetters("user", ["getUserName","getChildSelectedName"]),   
  },
  methods: {
    ...mapActions('coins',['aceptRejectCoin']),
    Done() {
      if(!this.requestSent){
        this.requestSent=true
        this.aceptRejectCoin({
          id:this.idCoins,
          value:true
        }).then(()=>{
          this.requestSent=false
          this.$router.push({name:'allow-coins'})
        })
      }
    },
    UnDone() {
      if(!this.requestSent){
        this.requestSent=true
        this.aceptRejectCoin({
          id:this.idCoins,
          value:false
        }).then(()=>{
          this.requestSent=false
          this.$router.push({name:'allow-coins'})
        })
      }
    }
  }
};
</script>
<style>
.biger-icon {
  font-size: 4em !important;
}
</style>
